import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ProjectDirectory.css';
import printWhiteSvg from 'images/print-white.svg';
import mailWhiteSvg from 'images/mail-white.svg';
import SimpleTable from 'components/shared/table/SimpleTable';
import Button from 'components/shared/button/Button';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';
import MessageModal from 'components/shared/modal/MessageModal';
import { formatPhoneNumber } from 'services/utils/text-util';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import { setShowEmailModal } from 'components/admin/projects/details/project-email-modal/store/actions';
import { getShowEmailModal } from 'components/admin/projects/details/project-email-modal/store/selectors';
import {
  getDirectory,
  getDirectoryPdf,
  getServiceProviderUsers,
  getContributorSettings,
  getUserSettings,
  getShowNewContributorModal,
  getShowEditUserModal,
  getShowSelectUsersForm,
  getShowInviteUserForm,
  getShowDirectoryPdfViewer,
  getCurrentContributor,
  getEditedUser,
} from 'components/admin/projects/details/project-directory/store/selectors';
import {
  loadDirectoryRequest,
  loadDirectoryPdfRequest,
  loadServiceProviderUsers,
  setShowNewContributorModal,
  setShowEditUserModal,
  setShowSelectUsersForm,
  setShowInviteUserForm,
  setShowDirectoryPdfViewer,
  setCurrentContributor,
  updateProjectContributor,
  toggleContributorSettings,
  toggleUserSettings,
  deleteProjectContributor,
  inviteUser,
  editUser,
  sendInvite,
  activationLink,
} from 'components/admin/projects/details/project-directory/store/actions';
import { sendProjectResourceEmails } from 'components/admin/projects/details/store/actions';
import NewContributorModal from 'components/admin/projects/details/project-directory/NewContributorModal';
import SelectUsersModal from 'components/admin/projects/details/project-directory/SelectUsersModal';
import UserModal from 'components/admin/projects/details/project-directory/UserModal';
import LabeledBellCheckBox from 'components/shared/checkbox/LabeledBellCheckBox';
import OutsideAlerter from 'components/shared/OutsideAlerter';
import settingsPng from 'images/settings.png';
import { getCurrentUser } from 'selectors/authentication';
import { Enterprise } from 'domain/enterprise';
import ProjectEmailModal from 'components/admin/projects/details/project-email-modal/ProjectEmailModal';
import { usersApi } from 'services/api/users-api';
class ProjectDirectory extends Component {
  constructor(props) {
    super(props);

    const { currentUser, currentProject } = props;
    this.showActions = Enterprise.showActions(currentUser);
    this.primary = currentProject
      ? Enterprise.primary(currentProject.contributor_type)
      : false;
  }

  componentDidMount() {
    if (this.props.currentProject) {
      this.props.dispatch(loadDirectoryRequest(this.props.currentProject.id));
    }
  }

  projectContributorsByPrimary = (primary) => {
    const contributors = this.props.directory.project_contributors.filter(
      (contrib) => contrib.primary === primary
    );
    if (primary) {
      return contributors;
    } else {
      return contributors.sort((pc1, pc2) =>
        pc1.csi_code.division < pc2.csi_code.division ? -1 : 1
      );
    }
  };

  mapContributors = (primary) => {
    const { currentProject } = this.props;
    return this.projectContributorsByPrimary(primary).map((contrib) => {
      return (
        <div key={contrib.id}>
          <div className="contributor-header">
            {this.showActions && (
              <div
                className="contributor-settings"
                onClick={() => this.handleContributorSettingsClick(contrib.id)}
              >
                <img src={settingsPng} alt="settings" />
                {this.props.contributorSettings[contrib.id] && (
                  <OutsideAlerter
                    onClickOutside={() =>
                      this.handleContributorSettingsClick(null)
                    }
                  >
                    <div className="settings-menu">
                      <div>
                        <div
                          className="settings-menu-item"
                          onClick={() =>
                            this.handleContributorSelectUsersClick(contrib)
                          }
                        >
                          Select Users
                        </div>
                        <div
                          className="settings-menu-item"
                          onClick={() =>
                            this.handleContributorInviteUserClick(contrib)
                          }
                        >
                          Invite User
                        </div>
                        {(contrib.company_type !== 'Client' ||
                          contrib.company_id !== currentProject.client_id) &&
                          contrib.company_type !== 'GeneralContractor' && (
                            <div
                              className="settings-menu-item settings-menu-delete"
                              onClick={() =>
                                this.handleContributorDeleteClick(contrib.id)
                              }
                            >
                              Delete
                            </div>
                          )}
                      </div>
                    </div>
                  </OutsideAlerter>
                )}
              </div>
            )}
            <div
              className={`contributor-title-container${
                this.showActions ? '' : ' no-settings'
              }`}
            >
              <h5 className="contributor-title">
                {primary
                  ? `${contrib.company_type_title} - ${
                      contrib.company.name || contrib.company.company_name
                    }`
                  : `${contrib.csi_code.division} ${contrib.csi_code.label} - ${contrib.company.name}`}
              </h5>
            </div>
            {this.showNotifications(contrib) && (
              <LabeledBellCheckBox
                checked={!!contrib.send_notifications}
                onChange={(value) =>
                  this.handleUpdateProjectContributor(contrib.id, {
                    sendNotifications: value,
                  })
                }
                label="Notifications"
              />
            )}
          </div>
          <SimpleTable
            className="projects-table contributors-table"
            rows={this.mapContributorUsers(contrib.users, contrib.id)}
            emptyMessage="No Users"
          />
        </div>
      );
    });
  };

  showNotifications = (contrib) => {
    const { currentUser } = this.props;
    return (
      this.showActions ||
      (contrib.company_id === currentUser.accountable_id &&
        contrib.company_type === currentUser.accountable_type)
    );
  };

  pendingInvite = (user) => {
    return !!user.invitation_sent_at && !user.invitation_accepted_at;
  };

  renderMenuForClient = (user, contribId) => {
    const { id, first_name, last_name } = user;
    const usedId = `${id}${contribId}`;
    const pendingInvite = this.pendingInvite(user);

    return (
      <div className="user-setting-wrapper">
        {this.showActions && (
          <div
            className="user-settings"
            onClick={() => this.handleUserSettingClick(usedId)}
          >
            <img src={settingsPng} alt="settings" />
            {this.props.userSettings[usedId] && (
              <OutsideAlerter
                onClickOutside={() => this.handleUserSettingClick(usedId)}
              >
                <div className="settings-menu">
                  <div>
                    <div
                      className="settings-menu-item"
                      onClick={() => this.toggleUserEditMenu(user)}
                    >
                      Edit User
                    </div>
                    {pendingInvite && (
                      <div
                        className="settings-menu-item"
                        onClick={() => this.handleSendInvite(user)}
                      >
                        Resend Invite
                      </div>
                    )}
                    {pendingInvite && (
                      <div
                        className="settings-menu-item"
                        onClick={() => this.handleGetActivationLink(user)}
                      >
                        Get Activation Link
                      </div>
                    )}
                  </div>
                </div>
              </OutsideAlerter>
            )}
          </div>
        )}
        {`${first_name} ${last_name}`}
      </div>
    );
  };

  mapContributorUsers = (users, contribId) => {
    const { currentUser } = this.props;

    return users.map((user) => {
      return [
        this.renderMenuForClient(user, contribId),
        user.title,
        user.email,
        `${formatPhoneNumber(user.phone_number)}${
          user.phone_ext ? ` ext ${user.phone_ext}` : ''
        }`,
        usersApi.resendInviteLink(currentUser, user) ? (
          <span
            className="linkable"
            onClick={() => this.handleResendInvite(user.id)}
          >
            Resend Invite
          </span>
        ) : (
          ''
        ),
      ];
    });
  };

  handleResendInvite = (id) => {
    usersApi.resendInvite(id);
  };

  handleContributorSettingsClick = (id) => {
    this.props.dispatch(toggleContributorSettings(id));
  };

  handleUserSettingClick = (id) => {
    this.props.dispatch(toggleUserSettings(id));
  };

  toggleUserEditMenu = (user) => {
    this.props.dispatch(setShowEditUserModal(true, user));
  };

  handleUpdateProjectContributor = (id, values) => {
    this.props.dispatch(
      updateProjectContributor(this.props.currentProject.id, id, values)
    );
  };

  handleContributorSelectUsersClick = (contrib) => {
    this.props
      .dispatch(
        loadServiceProviderUsers(contrib.company_type, contrib.company_id)
      )
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(setCurrentContributor(contrib));
          this.props.dispatch(setShowSelectUsersForm(true));
        }
      });
  };

  handleContributorInviteUserClick = (contrib) => {
    this.props.dispatch(setCurrentContributor(contrib));
    this.props.dispatch(setShowInviteUserForm(true));
  };

  handleSelectUsers = (values) => {
    const { currentProject, currentContributor, dispatch } = this.props;
    dispatch(
      updateProjectContributor(currentProject.id, currentContributor.id, values)
    ).then((response) => {
      if (response.ok) {
        this.handleSelectUsersClose();
      }
    });
  };

  handleInviteUser = (values) => {
    const { currentProject, currentContributor, dispatch } = this.props;
    dispatch(
      inviteUser(
        currentContributor.company_type,
        currentContributor.company_id,
        values
      )
    ).then((response) => {
      if (response.ok) {
        const userIds = currentContributor.users
          .map((usr) => usr.id)
          .concat(response.user.id);
        dispatch(
          updateProjectContributor(currentProject.id, currentContributor.id, {
            userIds: userIds,
          })
        ).then((response) => {
          if (response.ok) {
            this.handleInviteUserClose();
          }
        });
      }
    });
  };

  handleSendInvite = (user) => {
    this.props.dispatch(sendInvite(user)).then((response) => {
      if (response.ok) {
        this.setState({ inviteSentTo: user.email });
      }
    });
  };

  hideSendInviteSuccess = () => {
    this.setState({ inviteSentTo: '' });
  };

  renderSendInviteSuccess = () => {
    const inviteSentTo = !!this.state && this.state.inviteSentTo;
    return (
      !!inviteSentTo && (
        <MessageModal
          show={!!inviteSentTo}
          message={
            <div>
              Invitation successfully sent to
              <br />
              {inviteSentTo}
            </div>
          }
          onHide={this.hideSendInviteSuccess}
        />
      )
    );
  };

  handleGetActivationLink = (user) => {
    this.props.dispatch(activationLink(user)).then((response) => {
      if (response.ok) {
        this.setState({
          activationUser: `${user.first_name} ${user.last_name}`,
          activationLink: response.instructions.accept_invitation_url,
        });
      }
    });
  };

  hideActivationLinkSuccess = () => {
    this.setState({ activationUser: '', activationLink: '' });
  };

  renderActivationLinkSuccess = () => {
    const activationUser = !!this.state && this.state.activationUser;
    const activationLink = !!this.state && this.state.activationLink;
    return (
      !!activationUser &&
      !!activationLink && (
        <MessageModal
          show={!!activationUser && !!activationLink}
          message={
            <div className="activation-link">
              Activation Link for {activationUser}:<br />
              {activationLink}
            </div>
          }
          onHide={this.hideActivationLinkSuccess}
        />
      )
    );
  };

  handleSelectUsersClose = () => {
    this.props.dispatch(setShowSelectUsersForm(false));
  };

  handleInviteUserClose = () => {
    this.props.dispatch(setShowInviteUserForm(false));
  };

  handlePdfViewerClose = () => {
    this.props.dispatch(setShowDirectoryPdfViewer(false));
  };

  handleContributorDeleteClick = (id) => {
    this.props.dispatch(
      deleteProjectContributor(this.props.currentProject.id, id)
    );
  };

  handleAddContributor = () => {
    this.props.dispatch(setShowNewContributorModal(true));
  };

  handleViewPdf = () => {
    this.props
      .dispatch(loadDirectoryPdfRequest(this.props.currentProject.id))
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(setShowDirectoryPdfViewer(true));
        }
      });
  };

  handleShowEmailModal = () => {
    this.props.dispatch(setShowEmailModal(true));
  };

  handleSendEmail = (emailsData) => {
    this.props.dispatch(
      sendProjectResourceEmails(
        this.props.directory.id,
        'Directory',
        emailsData
      )
    );
  };

  buildEmailModalTitle = (project) => {
    return `Directory (Project #${project.number}: ${project.name})`;
  };

  buildEmailModalSubject = (project) => {
    return `${project.number}, ${project.name} - Directory`;
  };

  buildEmailModalMessage = (project) => {
    let location = '';
    if (project.building && project.building.location) {
      const buildingLocation = project.building.location;
      location = ` at ${buildingLocation.street_address_1}, ${buildingLocation.city} ${buildingLocation.state}`;
    }

    return `Please find the attached Directory for Project ${project.name}${location}. If you have any questions, please reach out via chat or email.`;
  };

  handleCloseEditUserModal = () => {
    this.props.dispatch(setShowEditUserModal(false));
  };

  handleEditUserOnSubmit = (values) => {
    this.props.dispatch(editUser(values));
  };

  getInitialValuesForEditedUser = (user) => {
    return {
      id: user.id,
      type: user.accountable_type,
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      phoneNumber: formatPhoneNumber(user.phone_number),
      phoneExt: user.phone_ext,
      title: user.title,
      accountableId: user.accountable_id,
    };
  };

  render() {
    return (
      <div>
        {this.props.directory && (
          <div className="project-directory">
            <div className="project-directory-header">
              <h3 className="contributors-table-title">Primary</h3>
              {(this.showActions || this.primary) && (
                <div className="buttons-container">
                  <Button
                    className="button button-gray"
                    icon={mailWhiteSvg}
                    label="Email"
                    onClick={this.handleShowEmailModal}
                  />
                  <Button
                    className="button button-gray"
                    icon={printWhiteSvg}
                    label="View PDF"
                    onClick={this.handleViewPdf}
                  />
                  {this.showActions && (
                    <Button
                      className="button button-orange"
                      label="Add Contributor"
                      onClick={this.handleAddContributor}
                    />
                  )}
                </div>
              )}
            </div>

            {this.projectContributorsByPrimary(true).length === 0 ? (
              <SimpleTable rows={[]} emptyMessage="No Contributors Yet" />
            ) : (
              this.mapContributors(true)
            )}

            <div className="project-directory-header">
              <h3 className="contributors-table-title">
                Subcontractors, Vendors
              </h3>
            </div>
            {this.projectContributorsByPrimary(false).length === 0 ? (
              <SimpleTable rows={[]} emptyMessage="No Contributors Yet" />
            ) : (
              this.mapContributors(false)
            )}

            {this.props.showNewContributorModal && <NewContributorModal />}

            {this.props.showEditUserModal && (
              <UserModal
                show={this.props.showEditUserModal}
                companyType={this.props.editedUser.accountable_type}
                handleClose={this.handleCloseEditUserModal}
                handleSubmit={this.handleEditUserOnSubmit}
                initialValues={this.getInitialValuesForEditedUser(
                  this.props.editedUser
                )}
              />
            )}

            {this.props.showSelectUsersForm && (
              <SelectUsersModal
                show={this.props.showSelectUsersForm}
                users={this.props.serviceProviderUsers}
                selectedUsers={this.props.currentContributor.users}
                handleSubmit={this.handleSelectUsers}
                handleClose={this.handleSelectUsersClose}
              />
            )}

            {this.props.showInviteUserForm && (
              <UserModal
                show={this.props.showInviteUserForm}
                companyType={this.props.currentContributor.company_type}
                handleSubmit={this.handleInviteUser}
                handleClose={this.handleInviteUserClose}
              />
            )}

            {this.props.showDirectoryPdfViewer && (
              <PdfViewer
                content={{
                  source: this.props.directoryPdf,
                  type: 'blob',
                }}
                show={this.props.showDirectoryPdfViewer}
                onClose={this.handlePdfViewerClose}
              />
            )}

            {this.props.showEmailModal && (
              <ProjectEmailModal
                title={this.buildEmailModalTitle(this.props.currentProject)}
                handleSendEmail={(emailsData) =>
                  this.handleSendEmail(emailsData)
                }
                projectId={this.props.currentProject.id}
                initialSubject={this.buildEmailModalSubject(
                  this.props.currentProject
                )}
                initialMessage={this.buildEmailModalMessage(
                  this.props.currentProject
                )}
              />
            )}

            {this.renderSendInviteSuccess()}
            {this.renderActivationLinkSuccess()}
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
    directory: getDirectory(state),
    directoryPdf: getDirectoryPdf(state),
    serviceProviderUsers: getServiceProviderUsers(state),
    contributorSettings: getContributorSettings(state),
    userSettings: getUserSettings(state),
    editedUser: getEditedUser(state),
    showNewContributorModal: getShowNewContributorModal(state),
    showEditUserModal: getShowEditUserModal(state),
    showSelectUsersForm: getShowSelectUsersForm(state),
    showInviteUserForm: getShowInviteUserForm(state),
    showDirectoryPdfViewer: getShowDirectoryPdfViewer(state),
    currentContributor: getCurrentContributor(state),
    currentUser: getCurrentUser(state),
    showEmailModal: getShowEmailModal(state),
  };
})(ProjectDirectory);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-directory/ProjectDirectory.js